export enum VerifyStatus {
    /** 未认证 */
    Unverified = 'unverified',
    /** 认证审核中 */
    Open = 'open',
    /** 认证已通过 */
    Approved = 'approved',
    /** 认证已过期 */
    Expired = 'expired'
}

export interface VerifyProfile {
    owner: {
        _id: string;
        status: VerifyStatus;
        expire_time?: string;
    };
    corp: {
        _id: string;
        status: VerifyStatus;
        expire_time?: string;
    };
    is_trigger_inherit: boolean;
}
